import { Button } from "design-system/atoms/Button"
import { ArrowLeft, NotebookPen } from "lucide-react"
import { useTranslation } from "react-i18next"

interface NoteControlsProps {
  isNoteMode: boolean
  onToggle: () => void
}

export function NoteControls({ isNoteMode, onToggle }: NoteControlsProps) {
  const { t } = useTranslation()

  return (
    <Button type="button" size="default" variant="secondary" onClick={onToggle}>
      {isNoteMode ? (
        <>
          <ArrowLeft />
          <span>{t("conversations.chat.notes.replyToConversation")}</span>
        </>
      ) : (
        <>
          <NotebookPen />
          <span>{t("conversations.chat.notes.addNote")}</span>
        </>
      )}
    </Button>
  )
}
